import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { useAppSelector } from '../../redux/hooks';
import { useSidebar } from '../../redux/hooks/useSidebar';

// Selectors
import { selectGlobalLoading } from '../../redux/slices/uiSlice';

// Components
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import NotificationSystem from '../../components/NotificationSystem';
import LoadingOverlay from '../../components/LoadingOverlay';

// Constants
const DRAWER_WIDTH_EXPANDED = 280;
const DRAWER_WIDTH_COLLAPSED = 72;
const HEADER_HEIGHT = 64;

const MainLayout = () => {
  const globalLoading = useAppSelector(selectGlobalLoading);
  const { sidebarOpen: open } = useSidebar();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', backgroundColor: 'background.paper' }}>
      <CssBaseline />
      <Header />
      <Box sx={{ 
        display: 'flex', 
        flex: 1, 
        overflow: 'hidden', 
        backgroundColor: 'background.paper',
        mt: `${HEADER_HEIGHT}px`, // Account for fixed header
      }}>
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'background.paper',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'auto',
            }}
          >
            <Box sx={{ p: 2 }}>
              <Outlet />
            </Box>
          </Box>
        </Box>
      </Box>
      <NotificationSystem />
      {globalLoading && <LoadingOverlay />}
    </Box>
  );
};

export default MainLayout;